// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608180415/js/" + chunkId + "." + {"44":"12914b2a","225":"f939fc93","481":"0db6c07b","486":"8a5f4df4","770":"74b66904"}[chunkId] + ".0.22231909843944908.chunk.js";
};